import { render, staticRenderFns } from "./ticket-verify.vue?vue&type=template&id=3be60af7&scoped=true"
import script from "./ticket-verify.vue?vue&type=script&lang=js"
export * from "./ticket-verify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be60af7",
  null
  
)

export default component.exports